import React, { useState, useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { auth } from '../config/supabase';

const ProtectedRoute = ({ children }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  const location = useLocation();

  useEffect(() => {
    checkAuth();
  }, []);

  const checkAuth = async () => {
    try {
      console.log('🔐 ProtectedRoute: Checking authentication for:', location.pathname);
      
      // Get current session
      const { data: { session } } = await auth.getSession();
      
      if (!session) {
        console.log('❌ ProtectedRoute: No active session found');
        setIsAuthenticated(false);
        setIsAdmin(false);
        setIsLoading(false);
        return;
      }
      
      console.log('✅ ProtectedRoute: Active session found');
      setIsAuthenticated(true);
      
      // Check if user is admin
      const adminStatus = await auth.isAdmin();
      console.log('🛡️ ProtectedRoute: Admin status:', adminStatus);
      
      if (!adminStatus) {
        console.log('❌ ProtectedRoute: User is not an admin');
        // Sign out non-admin users
        await auth.signOut();
        setIsAuthenticated(false);
        setIsAdmin(false);
        setIsLoading(false);
        return;
      }
      
      console.log('✅ ProtectedRoute: User is authenticated admin');
      setIsAdmin(true);
      setIsLoading(false);
      
    } catch (error) {
      console.error('❌ ProtectedRoute: Authentication check failed:', error);
      setIsAuthenticated(false);
      setIsAdmin(false);
      setIsLoading(false);
    }
  };

  // Show loading spinner while checking authentication
  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-gray-900">
        <div className="animate-pulse flex flex-col items-center">
          <div className="h-12 w-12 rounded-full border-4 border-white border-t-transparent animate-spin mb-3"></div>
          <div className="text-white">Verifying access...</div>
        </div>
      </div>
    );
  }

  // Redirect to login if not authenticated or not admin
  if (!isAuthenticated || !isAdmin) {
    console.log('🚫 ProtectedRoute: Redirecting to login page');
    return <Navigate 
      to="/admin-login" 
      state={{ from: location.pathname }} 
      replace 
    />;
  }

  // User is authenticated and is an admin, render the protected content
  console.log('✅ ProtectedRoute: Rendering protected content');
  return children;
};

export default ProtectedRoute; 